'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var DownloadLienStatementButton = (_dec = (0, _mobxReact.inject)('FunderStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(DownloadLienStatementButton, _Component);

  function DownloadLienStatementButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DownloadLienStatementButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DownloadLienStatementButton.__proto__ || Object.getPrototypeOf(DownloadLienStatementButton)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'isDownloading', _descriptor, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DownloadLienStatementButton, [{
    key: 'downloadLienStatement',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _props, FunderStore, contact, contactType, lawfirm;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, FunderStore = _props.FunderStore, contact = _props.contact, contactType = _props.contactType, lawfirm = _props.lawfirm;


                this.isDownloading = true;

                _context.prev = 2;
                _context.next = 5;
                return FunderStore.downloadContactTemplate(contact, contactType, this.contactTemplateId, lawfirm);

              case 5:
                _context.prev = 5;

                this.isDownloading = false;
                return _context.finish(5);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2,, 5, 8]]);
      }));

      function downloadLienStatement() {
        return _ref2.apply(this, arguments);
      }

      return downloadLienStatement;
    }()
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Button2.default,
        {
          disabled: this.isDownloading,
          onClick: this.downloadLienStatement
        },
        this.isDownloading ? 'Downloading...' : 'Download Lien Statement'
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'contactTemplateId',
    get: function get() {
      var FunderStore = this.props.FunderStore;

      return (0, _get3.default)(FunderStore, 'templateAttorney.id');
    }
  }]);

  return DownloadLienStatementButton;
}(_react.Component), _class3.propTypes = {
  contact: _propTypes2.default.object.isRequired,
  contactType: _propTypes2.default.string.isRequired,
  FunderStore: _propTypes2.default.object.isRequired,
  lawfirm: _propTypes2.default.object.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'isDownloading', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
})), _class2)) || _class) || _class) || _class);
var _default = DownloadLienStatementButton;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DownloadLienStatementButton, 'DownloadLienStatementButton', '/app/src/components/page-case-search-results/DownloadLienStatementButton.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case-search-results/DownloadLienStatementButton.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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